import { Injectable, signal } from '@angular/core';
import { Theme } from './theme.model';
import { Flag } from './flags';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  theme = signal<Theme>({} as Theme);
  themeId = signal<string>('');
  word = signal('');
  defaultLang = signal<Flag | null>(JSON.parse(localStorage.getItem('lang') || '{}'));

  constructor() {
    const defaultLang$ = toObservable(this.defaultLang);
    defaultLang$.subscribe((value) => {
      localStorage.setItem('lang', value ? JSON.stringify(value) : '');
    });
  }
}
